import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { ResearchScreen } from '@/screens/research/ResearchScreen';
import { ResearchHistoryScreen } from '@/screens/research/ResearchHistoryScreen';
import { ResearchHistoryDetailScreen } from '@/screens/research/ResearchHistoryDetailScreen';
import { ResearchStackParamList } from './types';

const Stack = createStackNavigator<ResearchStackParamList>();

export const ResearchNavigator: React.FC = () => {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="ResearchMain" component={ResearchScreen} />
      <Stack.Screen name="ResearchHistory" component={ResearchHistoryScreen} />
      <Stack.Screen name="ResearchHistoryDetail" component={ResearchHistoryDetailScreen} />
    </Stack.Navigator>
  );
};


